var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTowardstheright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.62208 23.6197H32.9832L21.7764 34.8212C21.53 35.0677 21.3346 35.3604 21.2014 35.6825C21.0681 36.0045 20.9996 36.3497 20.9997 36.6982C20.9998 37.0468 21.0686 37.3919 21.2021 37.7139C21.3356 38.0358 21.5312 38.3283 21.7777 38.5747C22.2756 39.0723 22.9508 39.3517 23.6547 39.3514C24.0033 39.3513 24.3484 39.2825 24.6704 39.149C24.9923 39.0156 25.2848 38.8199 25.5312 38.5734L41.1798 22.9274C41.7121 22.3978 41.9664 21.6951 41.9533 21.0002V20.995C41.9615 20.6377 41.8972 20.2825 41.7643 19.9508C41.6313 19.6191 41.4325 19.3178 41.1798 19.0651L25.5312 3.41915C25.0336 2.92123 24.3587 2.64136 23.6547 2.64111C22.9508 2.64087 22.2756 2.92026 21.7777 3.41784C21.2798 3.91541 20.9999 4.5904 20.9997 5.29432C20.9994 5.99824 21.2788 6.67343 21.7764 7.17135L32.9858 18.3755H2.62208C1.92666 18.3755 1.25973 18.6518 0.76799 19.1435C0.276254 19.6352 0 20.3022 0 20.9976C0 21.693 0.276254 22.3599 0.76799 22.8517C1.25973 23.3434 1.92666 23.6197 2.62208 23.6197V23.6197Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowardstheright);
export default __webpack_public_path__ + "static/media/towards the right.f3cfd82c.svg";
export { ForwardRef as ReactComponent };